import { authenticatedDelete, authenticatedGet } from "../base/util/api";
import { showSuccess } from "../base/util/alerts";
import { logError } from "../base/util/alerts";

export const NOTIFICATIONS_FETCH = "NOTIFICATIONS_FETCH";
export const NOTIFICATIONS_SET = "NOTIFICATIONS_SET";

export const loadNotifications = () => (dispatch) => {
  dispatch({ type: NOTIFICATIONS_FETCH });
  return authenticatedGet(`admin/notifications`)
    .then((res) => {
      dispatch({
        type: NOTIFICATIONS_SET,
        value: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const deleteNotification = (id) => (dispatch) => {
  return authenticatedDelete(`notifications/${id}`)
    .then((res) => {
      showSuccess(res.message);
      dispatch(loadNotifications());
    })
    .catch((msg) => logError(msg.message));
};
